import { queryOptions } from '@tanstack/react-query'
import { listWorkspaces } from '../features/workspaces/services'
import { cacheDuration } from '../shared'
import { getQueryKey, queryFunctions } from '~/services'
import { useQueryKeys } from '../hooks'
import { getApiClient } from '../stores'
import { GetWorkspacePreferenceProps, WorkspacePreferences } from '~/services/preferences/workspacePreferences'
import { resolveKey } from '~/services/preferences/preferences'

export const workspacesQueryOptions = () => {
  return queryOptions({
    staleTime: cacheDuration.short,
    queryKey: getQueryKey('workspaces_'),
    queryFn: async () => {
      return listWorkspaces()
    },
    meta: {
      errorMessage: 'Failed to retrieve your workspaces, please try again later',
    },
  })
}

export const workspacePreferencesQueryOptions = <T extends keyof WorkspacePreferences>(
  workspaceId: string,
  props: GetWorkspacePreferenceProps<T>
) => {
  return queryOptions({
    queryKey: getQueryKey('workspaces_/$workspaceId_/preferences/$path', { path: resolveKey(props), workspaceId }),
    queryFn: async () => queryFunctions['workspaces_/$workspaceId_/preferences/$path']({ workspaceId, ...props }),
    staleTime: cacheDuration.medium,
  })
}

export const workspaceHandleAvailableQueryOptions = (handle: string) => {
  const { checkWorkspaceHandle } = useQueryKeys()

  return queryOptions({
    staleTime: cacheDuration.short,
    queryKey: checkWorkspaceHandle(handle),
    enabled: !!handle,
    queryFn: async () => {
      if (!handle) {
        throw new Error('No handle provided')
      }
      return getApiClient()
        .checkHandleAvailability({ handle })
        .catch(() => ({ available: false, suggestions: [], usedBy: undefined }))
    },
  })
}
